// polyfills
import './polyfills/Array.find'
import './polyfills/Array.includes'
import './polyfills/Object.keys'
import './polyfills/String.includes'
import './polyfills/String.startsWith'
require('intersection-observer');

// polyfills from core-js
import 'core-js/modules/es.object.entries'

// setup axios
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// setup jquery
window.$ = window.jQuery = require('jquery');

// setup popper
window.Popper = require('popper.js').default;

// setup bootstrap
require('bootstrap');

// setup other deps
require('chart.js');
require('croppie');
require('daterangepicker');
require('select2');

// setup datatables
require('datatables.net');
require('datatables.net-bs4');
require('datatables.net-buttons');
require('datatables.net-buttons/js/buttons.flash');
require('datatables.net-buttons/js/buttons.html5');
require('datatables.net-buttons/js/buttons.print');
require('datatables.net-buttons/js/buttons.colVis');
require('datatables.net-buttons-bs4');
require('datatables.net-responsive');
require('datatables.net-responsive-bs4');

// setup sortable
import Sortable from "sortablejs";
window.Sortable = Sortable;

// setup moment
window.moment = require('moment-timezone');

// setup toastr
window.toastr = require('toastr');
toastr.options.positionClass = 'toast-top-right';
toastr.options.closeButton = true;
toastr.options.extendedTimeOut = 5000;
toastr.options.timeOut = 5000;
toastr.options.fadeOut = 250;
toastr.options.fadeIn = 250;

// setup fancybox
require('@fancyapps/fancybox');
window.$.fancybox.defaults.backFocus = false; // disable focusing back to active element after closing
window.$.fancybox.defaults.hash = false; // disable hash navigation to prevent scrolling to top when closed (only happens on ios devices)
window.$.fancybox.defaults.loop = true; // enable infinite navigation
window.$.fancybox.defaults.protect = true; // disable right-click context menu for simple image protection
window.$.fancybox.defaults.wheel = false; // disable mousewheel navigation
window.$.fancybox.defaults.buttons = [ // configure default buttons to show in toolbar
    'close',
];

// setup clipboardjs
var ClipboardJS = require('clipboard');
var clipboard = new ClipboardJS('.clipboardjs');

clipboard.on('success', function(e) {
    toastr.info('Copied to Clipboard!', null, {
        timeOut: 2000,
    });
});

clipboard.on('error', function(e) {
    toastr.error('Error Copying to Clipboard!', null, {
        timeOut: 2000,
    });
});

// setup vue
import Vue from 'vue'
window.Vue = Vue;
window.Vue.config.productionTip = false

// use vue extensions
window.Vue.use(require('vue-moment'));

// custom plugins
require('./custom-plugins/disable-video-contextmenu');
require('./custom-plugins/linkify');

// install service worker
if('serviceWorker' in navigator){
    navigator.serviceWorker.register('/service-worker.js');
}
